import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found — Let Go Wellness" description="The page you're looking for isn't here." path="/404" />
      <section className="mx-auto flex max-w-2xl flex-col items-center px-6 py-40 text-center">
        <div className="overline mb-4">404</div>
        <h1 className="font-serif text-5xl text-ink">This page has <span className="italic text-clay">let go.</span></h1>
        <p className="mt-6 font-sans text-base text-ink-soft">The page you're looking for isn't here — but we still are.</p>
        <Link to="/" data-testid="notfound-home" className="mt-10 rounded-full bg-ink px-8 py-3.5 font-sans text-sm text-linen transition-colors hover:bg-ink/85">Return home</Link>
      </section>
    </>
  );
}
